import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { OfficeEditor } from "../../Office/OfficeEditor";
import { _CashDeskAccountCDP } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { CashDeskAccountSelector } from "../CashDeskAccountSelector";
import { CompanyEditor } from "../../Company/CompanyEditor";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { CDPsEditor } from "../../../../contabilidad/budgetRPFactory/CDPsEditor";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { CashDeskAccountCDPCertificate } from "./CashDeskAccountCDPCertificate";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";

interface Props {
    idCashDeskAccount: number;
}

export const CashDeskCDP = ({ idCashDeskAccount }: Props) => {

    const cashdeskaccountcdp = useDataBean(_CashDeskAccountCDP);
    const single = Singleton.getInstance();
    const [verdoc, setverdoc] = useState<any>(null)
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [certificate, setcertificate] = useState<any>({ name: 'Ver Certificado', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [form, setForm] = useState<any>({
        Office: NaN,
        Year: _single.getCurrenYear(),
        IDCashDeskAccount: NaN,

    })
    useEffect(() => {
        getLista()
    }, [idCashDeskAccount])
    useEffect(() => {
        if (certificate.view) {
            verDocumentos();
        }
    }, [certificate.view]);
    const getLista = () => {

        cashdeskaccountcdp.instance.getCashDeskAccountCDPCatalog(form.Year, idCashDeskAccount).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        cashdeskaccountcdp.setBean({
            IDCashDeskAccount: cashdeskaccountcdp.bean.IDCashDeskAccount,
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        cashdeskaccountcdp.deleteItemVoid(cashdeskaccountcdp.bean.IDCashDeskAccountCDP).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(BankingEntity.bean);
        cashdeskaccountcdp.instance.addCDPDocumentToCashDeskAccount(cashdeskaccountcdp.bean.IDCashDeskAccount, cashdeskaccountcdp.bean.DocumentLocation.IDDocument, cashdeskaccountcdp.bean.DocumentLocation.Since).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCashDeskAccountCDP', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Fecha del Documento', property: 'DocumentDate', visible: true },
        { title: 'Número Documento', property: 'Mnemonic', visible: true },
        { title: 'Número Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Valor del CDP', property: 'CDPValue', visible: true },
        { title: 'Valor por Comprometer', property: 'RPValue', visible: true },
        { title: 'Disponible', property: 'LeftValue', visible: true },
        { title: 'Porcentaje de Uso', property: 'Percent', visible: true },




    ]
    const verDocumentos = () => {

        if (cashdeskaccountcdp.bean.IDDocument && cashdeskaccountcdp.bean.DocumentDate) {
            _documentos.instance.getPdfAccountantDocument(cashdeskaccountcdp.bean.IDDocument, null, cashdeskaccountcdp.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setcertificate({ ...certificate, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Consultar / Ver Documento CDP', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setcertificate({ ...certificate, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultar CDPs asociados a la Caja Menor">
            <div className="row">
                <div className="col-md-4">

                    <YearSelector value={form.Year} tittle="Año" onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-send-plane-fill" eventClick={getLista}>Buscar</BasicButton>
                </div>

            </div>
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={cashdeskaccountcdp.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">


                            <div className="col-md-6"> <OfficeEditor id={form.Office} onchange={(e) => { setForm({ ...form, "Office": e }) }} /> </div>
                            <div className="col-md-6">
                                <CashDeskAccountSelector label='Cajas Menores' office={form.Office} id={cashdeskaccountcdp.bean.IDCashDeskAccount} onchange={(e) => { cashdeskaccountcdp.setBean({ ...cashdeskaccountcdp.bean, "IDCashDeskAccount": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <CDPsEditor value={cashdeskaccountcdp.bean.IDDocument} onChange={(e) => { cashdeskaccountcdp.setBean({ ...cashdeskaccountcdp.bean, "IDDocument": e.IDDocument, "DocumentLocation": e }) }} />
                            </div>

                        </div>
                    </Modal>
                    <Modal modal={certificate} updateModal={setcertificate}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                    IDDocument={cashdeskaccountcdp.bean.IDDocument}
                                    Since={cashdeskaccountcdp.bean.DocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}